import React from "react";
import { Menu } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
  const { pathname } = useLocation();
  const history = useNavigate();

  function getItem(label, key) {
    return { key, label };
  }

  const items = [
    getItem("Assets Insight", "0", 0),
    getItem("Staking Risk", "1", 1),
    getItem("DeFi Shield / Light DeFi", "2", 2),
    getItem("Counterparty Risk ", "3", 3),
    getItem("Light NFT", "4", 4),
    getItem("Custody Shield", "5", 5),
    getItem("Clients", "6", 6),
    getItem("Recycle Bin", "7", 7),
  ];

  const navigateFnc = (key) => {
    switch (key) {
      case "0":
        return history("/");
      case "1":
        return history("/stakingrisk");

      case "2":
        return history("/defi-shield");
      case "3":
        return history("/counterparty-risk");
      case "4":
        return history("/light-ntf");
      case "5":
        return history("/wallet-shield");
      case "6":
        return history("/clients");
      case "7":
        return history("/user/trash");

      default:
        return history("/");
    }
  };

  const selectedKeysFnc = () => {
    switch (pathname) {
      case "/":
        return "0";
      case "/stakingrisk":
        return "1";
      case "/defi-shield":
        return "2";
      case "/counterparty-risk":
        return "3";
      case "/light-ntf":
        return "4";
      case "/wallet-shield":
        return "5";
      case "/clients":
        return "5";
      case "/user/trash":
        return "7";

      default:
        return "0";
    }
  };
  return (
    <div className="sidebar_box">
      <Menu
        // style={{ width: 200 }}
        onSelect={(e) => navigateFnc(e.key)}
        onClick={(e) => navigateFnc(e.key)}
        defaultSelectedKeys={() => selectedKeysFnc()}
        mode="inline"
        items={items}
      />
    </div>
  );
};

export default Sidebar;
